import React from "react";
import { Box, CircularProgress, Dialog, Typography } from "@mui/material";

import { StyledBookingFlowButton } from "../../BookingScheduleContainer/BookingScheduleContainer.style";
import { paletteColors } from "../../../../styles/muiTheme";
import { MESSAGES } from "../constants";

interface IPaymentProcessingOverlayProps {
  open: boolean;
  onClose: () => void;
}

export const PaymentProcessingOverlay = ({
  open,
  onClose,
}: IPaymentProcessingOverlayProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="payment-processing-title"
      aria-describedby="payment-processing-description"
      PaperProps={{
        sx: {
          padding: "16px",
          borderRadius: "10px",
          border: "1px solid rgba(0, 0, 0, 0.1)",
          boxShadow:
            "0px 10px 7.5px rgba(0, 0, 0, 0.1), 0px 4px 3px rgba(0, 0, 0, 0.1)",
          margin: "16px",
          maxWidth: "440px",
        },
      }}
    >
      <Box className="flex flex-col items-center gap-4">
        <Box className="flex flex-col items-center gap-2">
          <Box
            sx={{
              display: "flex",
              padding: "12px",
              borderRadius: "9999px",
              backgroundColor: "rgba(253, 185, 19, 0.1)",
            }}
          >
            <CircularProgress
              size={32}
              thickness={4}
              sx={{ color: paletteColors.primary.main }}
            />
          </Box>
          <Typography
            id="payment-processing-title"
            textAlign="center"
            sx={{
              fontFamily: "geograph-medium, sans-serif",
              fontSize: "18px",
              lineHeight: "28px",
              fontWeight: 600,
              color: "#0A0A0A",
            }}
          >
            {MESSAGES.PAYMENT_PROCESSING_TITLE}
          </Typography>
          <Typography
            id="payment-processing-description"
            textAlign="center"
            sx={{
              fontFamily: "geograph-regular, sans-serif",
              fontSize: "14px",
              lineHeight: "20px",
              color: "#717182",
              maxWidth: "398px",
            }}
          >
            {MESSAGES.PAYMENT_PROCESSING_DESCRIPTION}
          </Typography>
        </Box>
        <StyledBookingFlowButton
          color="primary"
          size="small"
          onClick={onClose}
          sx={{
            fontFamily: "geograph-medium, sans-serif",
            fontSize: "12px",
            lineHeight: "12px",
            fontWeight: 500,
            height: "32px",
            minWidth: "unset",
            width: "auto",
            paddingX: "20px",
            borderRadius: "100px",
            textTransform: "none",
          }}
        >
          OK
        </StyledBookingFlowButton>
      </Box>
    </Dialog>
  );
};

export default PaymentProcessingOverlay;
